<template>
    <performance-common-dialog
        :title="title"
        ref="performanceCommonDialog"
        @close="dialogClose"
        :width="'1300px'"
    >
        <template #top>
            <el-form
                class="form-container"
                ref="formRef"
                label-position="right"
                :model="config.form"
                label-width="100px"
            >
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="发车单：" prop="dispatchNo">
                            <span>{{ dispatchNo }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="站点地址：" prop="siteAddress">
                            <span class="show-tip"
                                ><el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="arrivalInfo.siteAddress"
                                    placement="top"
                                >
                                    <el-button>
                                        {{ arrivalInfo.siteAddress }}</el-button
                                    >
                                </el-tooltip></span
                            >
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="仓库名称：" prop="whName">
                            <span>{{ arrivalInfo.whName }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </template>
        <template #table-list>
            <!-- 表格 -->
            <dispatch-attach-table
                :infoId="arrivalInfo.id"
                :status="arrivalInfo.status"
                :dictData="dictData"
            >
            </dispatch-attach-table>
            <!-- 表格 -->
        </template>
    </performance-common-dialog>
</template>
<script>
import config from './config.js';
import PerformanceCommonDialog from '@/modules/transport/otp/components/PerformanceCommonDialog';
import DispatchAttachTable from './DispatchAttachTable';

export default {
    name: 'dispatchArrivalCheckIn',
    components: { PerformanceCommonDialog, DispatchAttachTable },
    props: {
        title: {
            type: String,
            default: '附件页面'
        },
        arrivalInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        dispatchNo: {
            type: String,
            default () {
                return '';
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            config: config,
            loading: false,
            totalData: [],
            pageTotal: 0,
            currentPage: 1
        };
    },
    methods: {
        dialogClose () {
            this.$emit('components-close');
        }
    },
    mounted () {
        this.$refs.performanceCommonDialog.show();
    }

};
</script>

<style scoped lang="less">
/deep/.el-form-item {
    margin: 0;
    .el-form-item__label {
        padding: 0;
    }
}
/deep/.el-tabs__header {
    margin-bottom: 0px;
}
/deep/.el-form-item__label {
    color: #999;
}
/deep/.el-form-item__content {
    color: #333;
}
.tms-performance-dialog .main-list-info {
    margin-top: 0px;
    padding-top: 0px;
}
/deep/.el-tooltip {
    border: none;
    padding: 0;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: text;
    &:hover {
        color: #333;
        background: none;
    }
}
</style>
